import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Container, Box, Typography, Tabs, Tab, Alert, Button,
} from '@mui/material';
import { Refresh } from '@mui/icons-material';
import AdminLayout from '../../components/admin/AdminLayout';
import LedgerSummaryCards from '../../components/admin/ledger/LedgerSummaryCards';
import LedgerEntriesTable from '../../components/admin/ledger/LedgerEntriesTable';
import LedgerRevenueComparison from '../../components/admin/ledger/LedgerRevenueComparison';
import ChainVerification from '../../components/admin/ledger/ChainVerification';
import ReconciliationReport from '../../components/admin/ledger/ReconciliationReport';
import ReversalRequests from '../../components/admin/ledger/ReversalRequests';
import { fetchLedgerDashboard } from '../../store/slices/ledgerSlice';

const TABS = ['Entries', 'Revenue', 'Reconciliation', 'Chain Integrity', 'Reversals'];

export default function LedgerDashboard() {
  const dispatch = useDispatch();
  const { dashboard, loading, error } = useSelector(s => s.ledger);
  const [tab, setTab] = useState(0);

  const loadDashboard = () => dispatch(fetchLedgerDashboard());

  useEffect(() => { loadDashboard(); }, []);

  return (
    <AdminLayout title="Ledger">
      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" fontWeight="bold">Accounting Ledger</Typography>
          <Button startIcon={<Refresh />} size="small" variant="outlined" onClick={loadDashboard}>
            Refresh
          </Button>
        </Box>

        {error.dashboard && (
          <Alert severity="error" sx={{ mb: 2 }}>{error.dashboard}</Alert>
        )}

        <LedgerSummaryCards dashboard={dashboard} loading={loading.dashboard} />

        <Box sx={{ mt: 3, borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto">
            {TABS.map((label, i) => <Tab key={label} label={label} value={i} />)}
          </Tabs>
        </Box>

        <Box sx={{ mt: 3 }}>
          {tab === 0 && <LedgerEntriesTable />}
          {tab === 1 && <LedgerRevenueComparison />}
          {tab === 2 && <ReconciliationReport />}
          {tab === 3 && <ChainVerification />}
          {tab === 4 && <ReversalRequests />}
        </Box>
      </Container>
    </AdminLayout>
  );
}
